import React from 'react';
// Importamos o componente da Farmácia que acabamos de criar
import Farmacia from './Farmacia'; 

function App() {
  return (
    <div className="App">
      {/* Aqui o React renderiza todo o seu cardápio de medicamentos */}
      <Farmacia />
    </div>
  );
}

export default App;